import React from "react";
import { styled } from "@mui/material/styles";
import { FileDetailsQuery$data } from "./__generated__/FileDetailsQuery.graphql";
import { Button, Container, Typography } from "@mui/material";
import { formatBytes, formatDate } from "../../utils/utils";
import KeyValueTable from "../../components/common/KeyValueTable";
import { Link } from "react-router-dom";
import { viewPath } from "../../utils/routeUtils";

export interface FilenDetailsTabProps {
  data: FileDetailsQuery$data;
}

const TabContainer = styled(Container)(() => ({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "left",
}));

const FileDetailsTab: React.FC<FilenDetailsTabProps> = ({ data }: FilenDetailsTabProps) => {
  if (!data?.node) {
    return <TabContainer></TabContainer>;
  }

  const {
    file_name,
    file_size,
    md5_digest,
    file_url,
    meta,
    created,
    source_solution,
    metrics,
    fault_models,
    produced_by,
  } = data.node;

  return (
    <TabContainer>
      <Typography>
        <strong>File Name: </strong>
        {file_name}
      </Typography>
      <Typography>
        <strong>File Size: </strong>
        {formatBytes(file_size)}
      </Typography>
      <Typography>
        <strong>MD5 Digest: </strong>
        {md5_digest}
      </Typography>

      {created && (
        <Typography>
          <strong>Created: </strong>
          {formatDate(created)}
        </Typography>
      )}

      {produced_by?.id && (
        <Typography>
          <strong>Produced by: </strong>
          <Link to={viewPath(produced_by.id)}>{produced_by.id}</Link>
        </Typography>
      )}

      {source_solution?.id && (
        <Typography>
          <strong>Source Solution: </strong>
          <Link to={viewPath(source_solution.id)}>{source_solution.id}</Link>
        </Typography>
      )}

      {fault_models && (
        <Typography>
          <strong>Fault models: </strong>
          {fault_models}
        </Typography>
      )}

      <Button href={file_url || ""}>Download</Button>

      {meta && <KeyValueTable header="Meta" data={meta} />}
      {metrics && <KeyValueTable header="Metrics" data={metrics} />}
    </TabContainer>
  );
};

export default FileDetailsTab;
